const NoData = () => {

    return (
        <div className="w-full py-4">
            <h1 className="text-center">~No Invoices Found~</h1>
        </div>
    )
}

export default NoData